import { removeDuplicateScores } from '../../../../components/charts/recharts.helpers';
import { DataPoint } from '../../../../components/charts/recharts.models';
import { EntityScores } from '../../../../models/overmind/analytics';
import { CompanyVariables } from '../../../../models/view/company-variables';

export function transformScores(scores: EntityScores[], companyVariables: CompanyVariables): DataPoint[] {
  const uniqueScores = removeDuplicateScores(scores, 'name');

  return uniqueScores
    .filter(score => !!score.scores[0].score)
    .map(personScore => {
      const personScoresObj: DataPoint = { name: personScore.name };

      personScore.scores.forEach(score => {
        personScoresObj[score.name.toLowerCase().includes('expected') ? 'Expected proficiency' : 'Average skill score'] = !!score?.score ? (companyVariables.useLevels ? score?.score.level : score?.score.percentage) : undefined;
      }); // These two need to be hard-coded for now (Harry's suggestion)

      return personScoresObj;
    });
}
